export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/sk.lyaml"));
at({});
};